import { DataGrid, TooltipV2 } from '@cimplico/components';
import { Link } from 'react-router-dom';
import { User, UserRoleEnum } from '../../types/user';
import { calcRelativeTime, formatDateTime } from '../../utilities/formatting';
import UserAvatar from '../../components/avatar/UserAvatar';
import UserRoleBadge from '../user-overview/UserRoleBadge';

type UserRowProps = {
    id: string;
    user: User;
};

function UserRow({ id, user }: UserRowProps): JSX.Element {
    return (
        <DataGrid.Row id={id} disabled={user.role === UserRoleEnum.ADMIN}>
            <div className="flex items-center gap-2">
                <UserAvatar user={user} />
                <section>
                    <Link to={`../users/${user.id}`}>
                        <p className="font-medium text-indigo-600 dark:text-indigo-400 text-sm cursor-pointer">
                            {user.firstName} {user.lastName}
                        </p>
                    </Link>
                    <label className="text-gray-500 text-sm">{user.email}</label>
                </section>
            </div>
            <TooltipV2 message={formatDateTime(user.updatedAt)}>
                <p className="text-gray-700 text-sm">{calcRelativeTime(user.updatedAt)}</p>
            </TooltipV2>
            <UserRoleBadge role={user.role} />
        </DataGrid.Row>
    );
}

export default UserRow;
